<script setup lang="ts">
import ChatToggleButton from '@/V2/chat/ChatToggleButton.vue';
import {
  iButton,
  iButtonSizes,
  iButtonTypes,
  iButtonStyles,
} from '@inscribe/signal';

defineProps<{
  title: string;
  backButtonLink?: string;
}>();
</script>

<template>
  <div
    class="page-header d-flex align-items-center w-100 i-px-11 i-py-8 i-gap-6"
  >
    <!-- back button -->
    <router-link v-if="backButtonLink" :to="backButtonLink">
      <i-button
        data-testid="page-header-back-button"
        left-icon="medium-arrows-left"
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.GHOST"
        :size="iButtonSizes.MEDIUM"
        data-dd-action-name="page-header-back-button"
      />
    </router-link>

    <!-- title and subtitle -->
    <div class="content flex-grow-1">
      <slot v-if="$slots.titleContent" name="title-content"></slot>
      <div class="title-container d-flex flex-column i-gap-1" v-else>
        <h1 class="title i-text-heading-5" data-testid="page-header-title">
          {{ title }}
        </h1>
      </div>
    </div>
    <div class="actions d-flex align-items-center i-gap-6">
      <slot name="actions" />
      <ChatToggleButton />
      <slot name="primary-actions" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-header {
  position: sticky;
  height: 68px;
  top: 0;
  z-index: 100;
  background-color: var(--base);
  border-bottom: 1px solid $light-neutral-60;

  h1 {
    margin: 0;
    padding: 0;
    color: var(--text-neutral-bold);
  }
}
</style>
